import React from 'react';

/**
 * Danke Nico für den genialen Namen den du dieser Komponente gabst
 * Danke Dennis für die globale Einführung des umgangssprachlichen Präteritums
 */
const campaignLogo = (props) => props.linkUrl ? <a href={props.linkUrl} target="_blank" rel="external noopener"><img src={props.src} alt="Logo" className="img-fluid" /></a> : <img src={props.src} alt="Logo" className="img-fluid" />;

export default campaignLogo;



// WEBPACK FOOTER //
// ./src/components/CampaignLogo/CampaignLogo.js